module.exports = __webpack_public_path__ + "static/media/cotrip.ac592e78.gif";